// extracted by mini-css-extract-plugin
module.exports = {"lazyLoader":"ob","hidden":"pb","preventTransition":"qb","divBgImg":"rb","loaded":"sb"};